import { createBrowserRouter, Navigate, Outlet } from 'react-router';

import { LoadingScreenComponent } from '@/components/LoadingScreenComponent';
import { PublicRouteOutlet } from '@/routes/outlets/PublicRouteOutlet';
import { RequireAuthOutlet } from '@/routes/outlets/RequireAuthOutlet';
import { RequireBusinessOutlet } from '@/routes/outlets/RequireBusinessOutlet';
import { RequireVerifiedEmailOutlet } from '@/routes/outlets/RequireVerifiedEmailOutlet';
import { VerifyEmailRouteOutlet } from '@/routes/outlets/VerifyEmailRouteOutlet';

export const applicationRoutes = createBrowserRouter([
	{
		path: '/login',
		element: <PublicRouteOutlet />,
		children: [
			{
				index: true,
				lazy: () =>
					import('@/pages/LoginPageComponent').then((m) => ({
						Component: m.LoginPageComponent,
					})),
			},
		],
	},
	{
		path: '/register',
		element: <PublicRouteOutlet />,
		children: [
			{
				index: true,
				lazy: () =>
					import('@/pages/RegisterPageComponent').then((m) => ({
						Component: m.RegisterPageComponent,
					})),
			},
		],
	},
	{
		path: '/forgot-password',
		element: <PublicRouteOutlet />,
		children: [
			{
				index: true,
				lazy: () =>
					import('@/pages/ForgotPasswordPageComponent').then((m) => ({
						Component: m.ForgotPasswordPageComponent,
					})),
			},
		],
	},
	{
		element: <RequireAuthOutlet />,
		children: [
			{
				path: '/verify-email',
				element: <VerifyEmailRouteOutlet />,
				children: [
					{
						index: true,
						lazy: () =>
							import('@/pages/VerifyEmailPageComponent').then((m) => ({
								Component: m.VerifyEmailPageComponent,
							})),
					},
				],
			},
			{
				element: <RequireVerifiedEmailOutlet />,
				children: [
					{
						path: '/no-business',
						lazy: () =>
							import('@/pages/NoBusinessPageComponent').then((m) => ({
								Component: m.NoBusinessPageComponent,
							})),
					},
					{
						path: '/', // Root path for authenticated users with verified email
						element: <RequireBusinessOutlet />,
						hydrateFallbackElement: <LoadingScreenComponent />,
						children: [
							{ index: true, element: <Navigate to="/dashboard" replace /> },
							{
								path: 'dashboard',
								lazy: () =>
									import('@/pages/DashboardPageComponent').then((m) => ({
										Component: m.DashboardPageComponent,
									})),
							},
							{
								path: 'businesses',
								element: <Outlet />,
								children: [
									{
										index: true,
										lazy: () =>
											import('@/pages/BusinessesPageComponent').then((m) => ({
												Component: m.BusinessesPageComponent,
											})),
									},
									{
										path: ':businessId',
										lazy: () =>
											import('@/pages/BusinessDetailPageComponent').then(
												(m) => ({
													Component: m.BusinessDetailPageComponent,
												}),
											),
									},
								],
							},
							{
								path: 'profile',
								lazy: () =>
									import('@/pages/ProfilePageComponent').then((m) => ({
										Component: m.ProfilePageComponent,
									})),
							},
							{
								path: 'billing',
								lazy: () =>
									import('@/pages/BillingPageComponent').then((m) => ({
										Component: m.BillingPageComponent,
									})),
							},
						],
					},
				],
			},
		],
	},
	{ path: '*', element: <Navigate to="/" replace /> },
]);
